<template lang="pug">
	section
		p.mb-5
			| Knowing this helps us better customize your experience
		section.radio-wrap
			.radio
				sfc-radio(v-model="userType" :radio-value="`parent`" label="My child(ren)" @click="nextFamily('parent')" name="parent")
		section.radio-wrap
			.radio
				sfc-radio(v-model="userType" :radio-value="`grandparent`" label="My grandchild(ren)" @click="nextFamily('grandparent')" name="grandparent")
		section.radio-wrap
			.radio
				sfc-radio(v-model="userType" :radio-value="`advisor`" label="My Client" @click="next('advisor')" name="advisor")
		section.radio-wrap
			.radio
				sfc-radio(@click="next('other')" v-model="userType" :radio-value="`other`" label="Other" name="other")
		.continue-button(v-if="withBackButton")
			sfc-button.mr-4(:blue="false" :back-arrow="true" @click="back()")
</template>

<style lang="stylus">
@import '~assets/css/variables.styl'

.already-have-an-account-text
	font-size: body-font-size-sm
	@media (max-width: 575px)
		font-size: body-font-size
		padding: 30px
		line-height: body-font-line-height-sm
.cursor-pointer
	cursor pointer

.continue-button
	margin-top: 60px
</style>

<script>
import SfcRadio from '@/common/components/inputs/v2/radio'
import SfcButton from '@/common/components/sfc-button'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	components:{
		SfcRadio,
		SfcButton
	},

	props: {
		withBackButton: {
			default: false
		}
	},

	data() {
		return {
			errors: {
			},
			userType: null,
			progressLength: 25
		}
	},

	methods: {
		login(){
			this.$emit(
				'next',
				90,
				"Log In to your account",
				"sfc-log-in-to-your-account",
				{
					progressLength: this.progressLength,
					title: "Who are you saving for?",
					component: "sfc-who-are-you-saving-for"
				}
			)
		},
		next(value){

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: value})

			SfcTrackingService.trackAnalyticsAction("Savings Center Onboard", "Saving For - next", value, 0)

			this.$emit('next', this.progressLength, "How old is your child?", "sfc-how-old-is-your-child")

		},

		nextFamily(value){
			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: value})

			SfcTrackingService.trackAnalyticsAction("Savings Center Onboard", "Saving For - next", value, 0)
			this.$emit('next', this.progressLength, "Where are you in your college savings journey?", "sfc-college-savings-journey")

		},

		back(){
			this.$emit('next', -1*this.progressLength, "What is your state of residence?", "sfc-what-is-your-state-of-residence")
		}
	}

}
</script>
